/**
 * @generated SignedSource<<ef27a5989553105cea3ce6e829ff2da2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ReferralsSummaryCardQuery$variables = {};
export type ReferralsSummaryCardQuery$data = {
  readonly referralHistory: {
    readonly currentMonth: {
      readonly earnings: {
        readonly subUnitAmount: number;
      } | null;
    };
  };
};
export type ReferralsSummaryCardQuery = {
  response: ReferralsSummaryCardQuery$data;
  variables: ReferralsSummaryCardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ReferralHistory",
    "kind": "LinkedField",
    "name": "referralHistory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ReferralsStats",
        "kind": "LinkedField",
        "name": "currentMonth",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrencyAmount",
            "kind": "LinkedField",
            "name": "earnings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subUnitAmount",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReferralsSummaryCardQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ReferralsSummaryCardQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "8b6daba3ef81bbbea84f64305cfad2cc",
    "id": null,
    "metadata": {},
    "name": "ReferralsSummaryCardQuery",
    "operationKind": "query",
    "text": "query ReferralsSummaryCardQuery {\n  referralHistory {\n    currentMonth {\n      earnings {\n        subUnitAmount\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "460e8fc56a748487cfea26f25843e8ef";

export default node;
